<template lang="pug">
.arigatou-wave {{ text }}
</template>

<style lang="scss" scoped>
</style>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "arigatou-wave",
  props: {
    length: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState(["userName"]),
    basePhrase() {
      return `${this.userName}さんありがとう`;
    },
    text() {
      if (this.length <= 0) return "";
      const baseCount = Math.ceil(this.length / this.basePhrase.length);
      return _.times(baseCount, () => this.basePhrase)
        .join("")
        .slice(0, this.length);
    }
  }
};
</script>
